export default {
  entidades: 'Entities',
  configuracion: 'Settings',
  usuarios: 'Users',
  modulos: 'Módulos y permisos',
  roles: 'Roles',
  parametros: 'Preferencias',
  logs: 'Logs del sistema',
  config: 'Configuraciones'
};



// WEBPACK FOOTER //
// ./src/common/lang/en/menu.js